export default __webpack_public_path__ + "static/media/whoisbitcoinsatoshimemecoinupdated.a8091edd.png";